import { render, staticRenderFns } from "./ShareAndEarn.vue?vue&type=template&id=469bd1e4&scoped=true&"
import script from "./ShareAndEarn.vue?vue&type=script&lang=ts&"
export * from "./ShareAndEarn.vue?vue&type=script&lang=ts&"
import style0 from "./ShareAndEarn.vue?vue&type=style&index=0&id=469bd1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469bd1e4",
  null
  
)

export default component.exports